export default "__VITE_PUBLIC_ASSET__d402b431__"